import React from "react";

const LOGO_URL = `${process.env.PUBLIC_URL || ""}/spc-logo.jpg`;

// Print-only branded header. Uses brand-blue text + rule (no background fill) so it
// always prints, even when the browser's "Background graphics" option is off.
export default function PrintHeader({ title, subtitle }) {
  return (
    <div className="print-only print-brand">
      <img src={LOGO_URL} alt="Performance Nutrition" style={{ height: 48, width: 48, objectFit: "contain" }} />
      <div>
        <p className="print-brand-title" style={{ fontWeight: 900, textTransform: "uppercase", fontSize: 18, letterSpacing: "-0.02em", lineHeight: 1.1 }}>
          Performance Nutrition
        </p>
        <p className="print-brand-sub" style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: "0.18em", marginTop: 3 }}>{title}</p>
        {subtitle && <p className="print-brand-sub" style={{ fontSize: 12, marginTop: 3 }}>{subtitle}</p>}
      </div>
    </div>
  );
}
